import createLucideIcon from '../createLucideIcon';

const XSquare = createLucideIcon('XSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['line', { x1: '9', x2: '15', y1: '9', y2: '15', key: '1shsy8' }],
  ['line', { x1: '15', x2: '9', y1: '9', y2: '15', key: 'f7djnv' }],
]);

export default XSquare;
